import { SEO } from '@/components/layout/SEO'
import { PageHeader, Btn, SectionTitle } from '@/components/ui'
import { C } from '@/constants/theme'
import { WA_URL } from '@/constants/data'

const VALUES = [
  { icon: '🏆', title: 'Quality First',    desc: 'Only SABS-approved OEM/OEE glass. No compromises on safety.' },
  { icon: '⚡', title: 'Fast Turnaround',  desc: 'Same-day service available. Chip repairs in under 30 minutes.' },
  { icon: '🚗', title: 'We Come to You',   desc: 'Mobile service across Gauteng — your schedule, your location.' },
  { icon: '💰', title: 'Fair Pricing',     desc: 'Transparent pricing, no hidden fees. Insurance claims accepted.' },
]

const FACTS = [
  ['📍', 'Based in',      'Midrand, Gauteng'],
  ['✅', 'Glass Quality', 'SABS Approved OEM/OEE'],
  ['🚗', 'Service',       'Mobile — We Come to You'],
  ['🔧', 'Coverage',      'All Makes & Models'],
]

export default function About() {
  return (
    <>
      <SEO
        title="About Us"
        description="GlassTech Pty Ltd — founded in Midrand by Lwando Mantshi. SABS-approved auto glass specialists committed to quality, convenience, and fair pricing across Gauteng."
        path="/about"
      />

      <PageHeader label="Our Story" title="About GlassTech" />

      <div style={{ background: C.white, minHeight: '80vh' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '60px 24px' }}>

          {/* Story + facts */}
          <div className="gt-two-col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, marginBottom: 56, alignItems: 'start' }}>
            <div>
              <h2 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 36, fontWeight: 700, color: C.text, margin: '0 0 20px' }}>Built on Trust & Precision</h2>
              <p style={{ color: C.textMid, lineHeight: 1.8, fontSize: 15, marginBottom: 16 }}>
                GlassTech Pty Ltd was founded in Midrand, Gauteng with one goal: to make quality auto glass services accessible, convenient, and affordable for every South African vehicle owner.
              </p>
              <p style={{ color: C.textMid, lineHeight: 1.8, fontSize: 15 }}>
                We use only SABS-approved OEM and OEE glass, and our mobile service means you don't need to leave home or the office. From chip repairs to full replacements, we've got you covered.
              </p>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              {FACTS.map(([icon, lab, val]) => (
                <div key={val} style={{ padding: 20, background: C.grayLight, border: `1px solid ${C.grayBorder}` }}>
                  <div style={{ fontSize: 22, marginBottom: 8 }}>{icon}</div>
                  <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 10, letterSpacing: 2, color: C.blue, textTransform: 'uppercase', marginBottom: 4 }}>{lab}</div>
                  <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 14, fontWeight: 700, color: C.text }}>{val}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Founder */}
          <div style={{ background: C.blueLight, border: `1px solid rgba(0,174,239,0.15)`, borderLeft: `4px solid ${C.blue}`, padding: '36px 44px', display: 'flex', gap: 32, alignItems: 'center', flexWrap: 'wrap', marginBottom: 56 }}>
            <div style={{ width: 80, height: 80, background: `linear-gradient(135deg, ${C.blue}, ${C.blueDark})`, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, flexShrink: 0 }}>👤</div>
            <div>
              <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 11, letterSpacing: 3, color: C.blue, textTransform: 'uppercase', marginBottom: 6 }}>Founder</div>
              <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 26, fontWeight: 700, color: C.text, marginBottom: 8 }}>
                Lwando <span style={{ color: C.blue }}>Mantshi</span>
              </div>
              <p style={{ color: C.textMid, lineHeight: 1.7, fontSize: 14, maxWidth: 500, margin: 0 }}>
                Lwando founded GlassTech with a commitment to making quality auto glass services affordable and convenient across Gauteng. His focus on mobile service and SABS-approved materials sets GlassTech apart from the rest.
              </p>
            </div>
          </div>

          {/* Values */}
          <SectionTitle label="Our Values" title="Why GlassTech" />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20, marginBottom: 48 }}>
            {VALUES.map(v => (
              <div key={v.title} style={{ padding: 24, background: C.grayLight, border: `1px solid ${C.grayBorder}`, textAlign: 'center', borderTop: `3px solid ${C.blue}` }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>{v.icon}</div>
                <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 16, fontWeight: 700, color: C.text, marginBottom: 8 }}>{v.title}</div>
                <div style={{ fontSize: 13, color: C.textMid, lineHeight: 1.6 }}>{v.desc}</div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div style={{ textAlign: 'center', padding: '40px 24px', background: C.grayLight, border: `1px solid ${C.grayBorder}` }}>
            <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 24, fontWeight: 700, color: C.text, marginBottom: 12 }}>Ready to get started?</div>
            <div style={{ color: C.textMid, marginBottom: 24, fontSize: 15 }}>Get a free, no-obligation quote today.</div>
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}><Btn>Get a Free Quote</Btn></a>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { .gt-two-col { grid-template-columns: 1fr !important; } }
      `}</style>
    </>
  )
}
